import { useTranslatableText } from '@/hooks/useTranslatableText'
import './TranslatableText.css'

interface TranslatableTextProps {
    text: string
    as?: 'span' | 'p' | 'div'
    className?: string
    title?: string
}

/**
 * Renders database text with translation support.
 * When the translation toggle is on, shows a shimmer wave while translating
 * then fades in the translated text.
 */
export function TranslatableText({
    text,
    as: Tag = 'span',
    className = '',
    title,
}: TranslatableTextProps) {
    const { text: displayText, isLoading, isTranslated } = useTranslatableText(text)

    if (isLoading) {
        return (
            <Tag className={`translatable-shimmer ${className}`} title={title}>
                {text}
            </Tag>
        )
    }

    return (
        <Tag
            className={`${isTranslated ? 'translatable-translated' : ''} ${className}`}
            title={title}
        >
            {displayText}
        </Tag>
    )
}
